import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '../views/IndexView.vue'
import TypeView from '../views/TypeView.vue'
import DetailView from '../views/DetailView.vue'
import SearchView from '../views/SearchView.vue'
import LinklView from '../views/LinklView.vue'
import TopView from '../views/TopView.vue'
import TestView from '../views/TestView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexView
  }
  ,{
    path: '/Type',
    name: 'TypeView',
    component: TypeView
  }
  ,{
    path: '/Detail',
    name: 'DetailView',
    component: DetailView
  }
  ,{
    path: '/Search',
    name: 'SearchView',
    component: SearchView
  }
  ,{
    path: '/Link',
    name: 'LinklView',
    component: LinklView
  }
  ,{
    path: '/Top',
    name: 'TopView',
    component: TopView
  }
  ,{
    path: '/test',
    name: 'TestView',
    component: TestView
  }
]

const router = new VueRouter({
  mode: 'history', // 切换到history模式
  routes
})

export default router
